import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=4f73437d&scoped=true&"
import script from "./Weekly.vue?vue&type=script&lang=js&"
export * from "./Weekly.vue?vue&type=script&lang=js&"
import style0 from "./Weekly.vue?vue&type=style&index=0&id=4f73437d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f73437d",
  null
  
)

export default component.exports